var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBankBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    fill: "url(#paint0_linear_355_444)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6667 51.6667V56.6667H23.3333V51.6667C23.3333 50.75 24.0833 50 25 50H55C55.9167 50 56.6667 50.75 56.6667 51.6667Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 38.3333H28.3333V50H31.6667V38.3333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3333 38.3333H35V50H38.3333V38.3333Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 38.3333H41.6667V50H45V38.3333Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6667 38.3333H48.3333V50H51.6667V38.3333Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3333 57.9167H21.6667C20.9833 57.9167 20.4167 57.35 20.4167 56.6667C20.4167 55.9834 20.9833 55.4167 21.6667 55.4167H58.3333C59.0167 55.4167 59.5833 55.9834 59.5833 56.6667C59.5833 57.35 59.0167 57.9167 58.3333 57.9167Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6167 29.5833L40.6167 23.5833C40.2833 23.45 39.7167 23.45 39.3833 23.5833L24.3833 29.5833C23.8 29.8167 23.3333 30.5 23.3333 31.1333V36.6667C23.3333 37.5833 24.0833 38.3333 25 38.3333H55C55.9167 38.3333 56.6667 37.5833 56.6667 36.6667V31.1333C56.6667 30.5 56.2 29.8167 55.6167 29.5833ZM40 34.1667C38.6167 34.1667 37.5 33.05 37.5 31.6667C37.5 30.2833 38.6167 29.1667 40 29.1667C41.3833 29.1667 42.5 30.2833 42.5 31.6667C42.5 33.05 41.3833 34.1667 40 34.1667Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_355_444",
    x1: -0.00000706085,
    y1: 86,
    x2: 55.0324,
    y2: -12.0181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#633F89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570864,
    stopColor: "#8F7D4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45F882"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBankBuilding);
export default __webpack_public_path__ + "static/media/icon_bank_building.c4d75d7efe93ca3193b939a61bce64a6.svg";
export { ForwardRef as ReactComponent };